import styled from "styled-components"

const Image = styled.div`
  width: 100%;
  img {
    width: 100%;
  }
`

export default Image
